import styled from "styled-components";

export const SidebarSticky = styled.div`
  overflow-x: hidden;
  margin: 0;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  @media (max-width: 991.98px) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    transition: all 0.5s;
    transform: translateY(100%);
    width: 100%;
    &.show {
      transform: translateY(0);
      .toggle {
        border-radius: 100%;
        svg {
          transform: scaleX(-1);
        }
      }
    }

    overflow-y: auto;
    height: 100%;
    ::-webkit-scrollbar {
      width: 3px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`;

export const SidebarHeaderSticky = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #363636;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 50px;
  padding: 10px 25px;
  @media (min-width: 1600px) {
    padding: 10px 30px;
  }
`;
export const SidebarStickyAction = styled.div`
  display: flex;

`;

export const SidebarStickyReset = styled.button`
  @media (min-width: 992px) {
    display:none;
  }
  .btn{
    font-weight:400;
    color:#E9242A;
    .text{
      font-size:12px !important;
    }
    &:hover{		
      color:#E9242A;
    }
  }
`;
export const SidebarStickyClose = styled.button`
  background-color: transparent;
  border: transparent;
  display: flex;
  flex: wrap;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  @media (min-width: 992px) {
    display: none;
  }
  > svg {
    fill: #363636;
  }
`;
export const SidebarStickyTitle = styled.div`
  text-align: left;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  @media (min-width: 992px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
export const SidebarStickyBody = styled.div`
  overflow-x: hidden;
  padding: 20px 0;
  @media (min-width: 992px) {
    ::-webkit-scrollbar {
      width: 3px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    overflow-y: auto;
    height: calc(100vh - 180px);
  }
  @media (min-width: 1200px) {
    height: calc(100vh - 220px);
  }
`;
export const SidbarStickyFooter = styled.div`
  height: 50px;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px 20px;
  @media (min-width: 1600px) {
    padding: 10px 20px;
  }
  position: sticky;
  bottom: 0;
  z-index: 2;
`;
export const SidebarStickyToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  margin: 0 -5px;
`;
export const SidebarItemToolbar = styled.div`
  position: relative;
  padding: 0 5px;
  button {
    padding: 0;
    margin: 0;
    display: flex;
  }
  .btn {
    text-transform: capitalize !important;
  }
`;

export const SidebarCard = styled.div`
  position: relative;
  text-align: center;
`;

export const SidebarCardHeader = styled.div`
  padding: 10px 20px;
  @media (min-width: 1600px) {
    padding: 10px 20px;
  }
  + .sidebar-body {
    padding-top: 0;
  }
`;
export const SidebarCardTitle = styled.div`
  text-align: left;
  color: #363636;
  position: relative;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
`;
export const SidebarCardBody = styled.div`
  padding: 10px 20px;
  @media (min-width: 1600px) {
    padding: 10px 20px;
  }
  .form-group {
    margin-bottom: 0;
  }
`;
export const SearchForm = styled.div`
  .input-group,
  .form-group {
    .form-control {
      background: #fff;
      border: 1px solid #eee;
      padding: 5px 15px;
      font-size: 14px;
      line-height: 24px;
      border-radius:0;
      &:focus {
        border-color: #373636;
      }
    }
    .input-group-append{
      > .btn{
        border-radius:0;
      }
    }
  }
  + .search-form {
    margin-top: 20px;
  }
`;
export const ListBadge = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px 30px -5px;
`;
export const BadgeTag = styled.label`
  color: #000;
  background-color: #fbe179;
  font-weight: 600;
  display: inline-block;
  border-radius: 30px;
  transition: color 0.5s ease-in-out, background-color 0.5s ease-in-out,
    border-color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
  cursor: pointer;
  margin: 5px;
  font-size: 14px;
  line-height: 24px;
  padding: 4px 8px;
  @media (min-width: 576px) {
    padding: 5px 15px;
  }
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 20px;
  }
  &:hover {
    border-color: #ebc322;
    background-color: #ebc322;
    color: #000;
    background-color: #fbe179;
    font-weight: 600;
    display: inline-block;
    border-radius:30px;
    transition: color .5s ease-in-out,background-color .5s ease-in-out,border-color .5s ease-in-out,box-shadow .5s ease-in-out;
    cursor: pointer;
    margin:5px;    
    font-size: 14px;
    line-height: 24px;
    padding: 4px 8px;
    @media (min-width: 576px) {
        padding: 5px 15px;
    }
    @media (min-width: 992px) {
        font-size: 16px;
        line-height: 20px;
    }
    &:hover{
        border-color: #ebc322;
        background-color: #ebc322;
        color: #000;
    }
  }
`
export  const Sidebar = styled.div`
`
export  const SidebarDefaultTitle = styled.div`
  margin-bottom: ${props=>props.mb};	
  font-weight:700;
  color:${props=>props.color};
  text-align: center;
  font-size: 18px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
  @media (min-width: 992px) {
    font-size: 24px;
    line-height: 34px;
  }
  @media (min-width: 1200px) {
    font-size: 30px;
    line-height: 40px;
  }
`
SidebarDefaultTitle.defaultProps = {
	color: "#373636",
	mb: "15px",
}

export  const SidebarDefault = styled.div`
  background-color:#fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 25px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius:15px;
  overflow:hidden;
  margin-bottom:30px;
  @media (min-width: 768px) {
    margin-bottom:40px;
  }
`
export  const SidebarDefaultBody = styled.div`
  position:relative;
  overflow:hidden;
  padding:20px 15px;
  @media (min-width: 768px) {
    padding:30px 20px;
  }
  @media (min-width: 1200px) {
    padding:30px;
  }
  + .phone-cta {
    margin-top:5px;
  }
  + .sidebar-body{
    padding-top:0;
  }
`
export  const BuildingImg = styled.div`
  position: absolute;
  bottom: -7%;
  left: 0;
  right: 0;
  margin: 0 10px;
`;
export  const BuildingTexture = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.2;
`;

export  const SidebarForm = styled.div`
  position: relative;
  z-index: 1;
  .form-title {
    /* color: #fff; */
    margin-bottom: 5px;
  }
  .form-subtitle {
    /* color: #fff; */
  }
  .form-action {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .btn {
      font-weight: 500;
      @media (min-width: 1600px) {
        > .text {
          padding: 12px 50px;
          font-size: 22px;
          line-height: 32px;
        }
      }
    }
  }
  /* .form-control {
    background-color: #232323;
    color: #fff;
    border-color: #232323;
    &::placeholder {
      color: #fff;
      font-weight: 500;
    }
    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
      border-color: #232323;
      &::placeholder {
        color: #fff;
      }
    }
  } */

  /* .css-13cymwt-control,
  .css-t3ipsp-control {
    background-color: #232323 !important;
    color: #fff !important;
    border-color: #232323 !important;
  }
  .css-t3ipsp-control {
    border-color: #232323 !important;
  }
  .css-qbdosj-Input,
  .css-19bb58m {
    color: #fff !important;
  }
  .css-1dimb5e-singleValue {
    color: #fff !important;
  }
  .css-1jqq78o-placeholder {
    color: #fff !important;
  } */
  .css-1nmdiq5-menu {    
    font-size:16px;
    line-height:24px;
  }
`;

export const SidebarSearch = styled.div`
  background-color: #eef0fd;
  border: 1px solid #babfdf;
  border-radius: 6px;
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  position: relative;
  .input-icon {
    > .form-control {
      @media (min-width: 1200px) {
        padding: 15px;
      }
      &::placeholder {
        color: #363636;
      }
      &:focus,
      &:active {
        &::placeholder {
          color: #363636;
        }
      }
    }
    .icon {
      width: 45px;
      background-color:#232020;
      > svg {
        fill: #fff;
        width: 20px;
      }
      &:hover {
        > svg {
          fill: #e9242a;
        }
      }
    }
    &.right {
      > .form-control {
        padding-right: 45px;
        padding-left: 15px;
      }
    }
  }
`;



export const SidebarStatic = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color:#fff;
  border-radius:15px;
  overflow:hidden;
  margin-bottom:30px;
  @media (min-width: 768px) {
    margin-bottom:40px;
  }
`;

export const SidebarStaticTitle = styled.div`
  text-align: left;
  position: relative;
  font-weight: 700;
  margin-bottom:10px;
  font-size: 16px;
  line-height: 24px;
  @media (min-width: 992px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
export const SidebarStaticBody = styled.div`
  padding:30px 20px;
  @media (min-width: 768px) {
    padding:30px;
  }
  @media (min-width: 1200px) {
    padding:30px 40px;
  }
  @media (min-width: 1600px) {
    padding:40px 50px;
  }
  &.bg-gray{
    background-color:#eef0fd;
  }
`;